import Controller from '@ember/controller';
import { type Registry as Services, service } from '@ember/service';
import type { LookerDashboard } from 'lumen/models';
import type MarketCustomReportingTemplatesRoute from 'lumen/routes/market/custom-reporting/templates';
import type { ModelFrom } from 'lumen/utils/routes';

export default class MarketCustomReportingTemplatesController extends Controller {
  declare model: ModelFrom<MarketCustomReportingTemplatesRoute>;

  // eslint-disable-next-line ember/no-unused-services
  @service declare access: Services['access'];

  get dashboards(): LookerDashboard[] {
    const dashboards = this.model.templates.lastSuccessful?.value;

    if (!dashboards) {
      return [];
    }

    return dashboards;
  }

  get isLoading(): boolean {
    return this.model.templates.isRunning;
  }
}
